import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyBytiUngwp4TZ3rVDv5kqnqzcQBWcTyR1U",
  authDomain: "twitter-clone-33e08.firebaseapp.com",
  databaseURL: "https://twitter-clone-33e08.firebaseio.com",
  projectId: "twitter-clone-33e08",
  storageBucket: "twitter-clone-33e08.appspot.com",
  messagingSenderId: "705074216278",
  appId: "1:705074216278:web:6e4d79af76e75709686af7",
  measurementId: "G-34B8WPBN9H"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();

export default db;